export enum ContragentType {
    LegalEntity = 'LegalEntity',
    IndividualEntrepreneur = 'IndividualEntrepreneur',
    SelfEmployed = 'SelfEmployed',
}

export const ContragentTypeUtil = {
    getStringValue: (type: ContragentType | null | undefined): string => {
        switch (type) {
            case ContragentType.LegalEntity:
                return 'Юридическое лицо';
            case ContragentType.IndividualEntrepreneur:
                return 'Индивидуальный предприниматель';
            case ContragentType.SelfEmployed:
                return 'Самозанятый';
            default:
                return '';
        }
    },
    getNameLabel: (type: ContragentType | null | undefined): string => {
        return type === ContragentType.IndividualEntrepreneur || type === ContragentType.SelfEmployed
            ? 'ФИО'
            : 'Название организации';
    },
    getOgrnLabel: (type: ContragentType | null | undefined): string => {
        return type === ContragentType.IndividualEntrepreneur ? 'ОГРНИП' : 'ОГРН';
    },
    isOgrnVisible: (type: ContragentType | null | undefined): boolean => {
        return type !== ContragentType.SelfEmployed;
    },
    isOgrnRequired: (type: ContragentType | null | undefined): boolean => {
        return type === ContragentType.IndividualEntrepreneur;
    },
};
